module.exports = __webpack_public_path__ + "images/柏纳长图_10-1.jpg?v=17c3b6ff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_10-1.jpg
 ** module id = 151
 ** module chunks = 1 2
 **/